<template>
  <v-form v-model="valid" ref="mainForm">
    <TextFieldLive code="pro_prenom" v-model="sasInscription.prenomProfessionnelSante" :live="liveSasInscription(7728)" />
    <TextFieldLive code="pro_nom" v-model="sasInscription.nomProfessionnelSante" :live="liveSasInscription(7729)" />
    <CatalogueLive code="pro_titre" v-model="sasInscription.titreProfessionnelSante" :live="liveSasInscription(7727)" />
    <TextFieldLive
      :eudoIf="estTitreAutre"
      code="pro_autre"
      v-model="sasInscription.precisionTitre"
      :live="liveSasInscription(7733)"
    />
    <TextFieldLive code="pro_org" v-model="sasInscription.nomOrganisation" :live="liveSasInscription(7734)" />
    <TextFieldLive code="pro_tel" v-model="sasInscription.telephoneProfessionnelSante" :live="liveSasInscription(7731)" />
    <NumberLive code="pro_poste" v-model="sasInscription.numeroDePoste" :live="liveSasInscription(7708)" />
    <TextFieldLive code="pro_courriel" v-model="sasInscription.courrielProfessionnelSante" :live="liveSasInscription(7730)" />
    <CaseACocherLive
      code="inscription_declaration"
      v-model="sasConsentement.declarationInformationsExactesEtConsentementProfessionelSante"
      :live="liveSasConsentement(8907)"
    />
  </v-form>
</template>

<script>

import StepFormWithValidation from "@/components/core/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import { DESC_ID, CODES_CATALOGUES } from "@/constants"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasInscription() {
      return this.sas.sasInscription
    },
    sasConsentement() {
      return this.sas.sasConsentement
    },
    estTitreAutre() {
      return this.getCatalogueCodeById(DESC_ID.TITRE_PROFESSIONNEL_SANTE, this.sasInscription.titreProfessionnelSante) == CODES_CATALOGUES.TITRE_PROFESSIONNEL_SANTE.AUTRE
    }
  },
  methods: {
    liveSasInscription(cle) {
      return { endpoint: "sas-inscription", cle: cle, fileId: this.sasInscription.id }
    },
    liveSasConsentement(cle) {
      return { endpoint: "sas-consentement", cle: cle, fileId: this.sasConsentement.id }
    }
  }
}
</script>

<style></style>
